import React from 'react';

const HeaderLeft = ({ children }) => <div className="ws-ui-editor-header__left">{children}</div>;

export default HeaderLeft;
